export default async function hideAddedToCartTooltip({ state }) {
  state.set(['showTourAddedToCartTooltip'], false);
  state.commit();
}
